"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingFilters = void 0;
const addDays_1 = __importDefault(require("date-fns/addDays"));
const addMonths_1 = __importDefault(require("date-fns/addMonths"));
const addWeeks_1 = __importDefault(require("date-fns/addWeeks"));
const addYears_1 = __importDefault(require("date-fns/addYears"));
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const ButtonGroup_1 = __importDefault(require("react-bootstrap/ButtonGroup"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const dateUtils = __importStar(require("../../utils/dateUtils"));
const DayPickerCustomInput_1 = require("../day-picker/DayPickerCustomInput");
const IconCalendar_1 = require("../icons/IconCalendar");
const IconChevronLeft_1 = require("../icons/IconChevronLeft");
const IconChevronRight_1 = require("../icons/IconChevronRight");
const MultiSelectAddons_1 = require("../multi-selects/MultiSelectAddons");
const MultiSelectResource_1 = require("../multi-selects/MultiSelectResource");
require("./BookingFilters.scss");
const BookingFilters = (props) => {
    var _a, _b;
    const [dayPickerVisible, setDayPickerVisible] = (0, react_1.useState)(false);
    function handlePrevNext(amount) {
        switch (props.view) {
            case "day":
                props.onDateChange((0, addDays_1.default)(props.date, amount));
                break;
            case "week":
                props.onDateChange((0, addWeeks_1.default)(props.date, amount));
                break;
            case "month":
                props.onDateChange((0, addMonths_1.default)(props.date, amount));
                break;
            case "year":
                props.onDateChange((0, addYears_1.default)(props.date, amount));
                break;
        }
    }
    function renderedViewArea() {
        // Only show view buttons if the onViewChange handler is defined.
        if (props.onViewChange && props.viewButtons) {
            const buttons = props.viewButtons.map((dateRange, index) => {
                let buttonText = "";
                switch (dateRange) {
                    case "day":
                        buttonText = "Tag";
                        break;
                    case "week":
                        buttonText = "Woche";
                        break;
                    case "month":
                        buttonText = "Monat";
                        break;
                    case "year":
                        buttonText = "Jahr";
                        break;
                }
                return (react_1.default.createElement(Button_1.default, { key: index, variant: "outline-secondary", active: props.view === dateRange, onClick: () => props.onViewChange(dateRange) }, buttonText));
            });
            return react_1.default.createElement(ButtonGroup_1.default, null, buttons);
        }
        else {
            return react_1.default.createElement("div", { className: "flex-grow-1" });
        }
    }
    const [fromDate, toDate] = dateUtils.getViewRange((_a = props.view) !== null && _a !== void 0 ? _a : "day", props.date);
    return (react_1.default.createElement("div", { className: "booking-filters " + ((_b = props.className) !== null && _b !== void 0 ? _b : "") },
        props.resources !== undefined && props.onResourcesChange && (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement(MultiSelectResource_1.MultiSelectResource, { selectedResourceIds: props.resources, onSelectedResourceIdsChange: props.onResourcesChange }))),
        props.addonTypes !== undefined && props.onAddonTypesChange && (react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement(MultiSelectAddons_1.MultiSelectAddons, { selectedAddonTypes: props.addonTypes, onSelectedAddonTypesChange: props.onAddonTypesChange }))),
        react_1.default.createElement(Row_1.default, { className: "booking-filters-dates mb-2" },
            react_1.default.createElement(Col_1.default, { xs: 12, className: "d-flex justify-content-between align-items-center" },
                react_1.default.createElement(ButtonGroup_1.default, null,
                    react_1.default.createElement(Button_1.default, { className: "filter-prev-button", variant: "outline-secondary", onClick: () => handlePrevNext(-1), disabled: fromDate <= props.minDate },
                        react_1.default.createElement(IconChevronLeft_1.IconChevronLeft, null)),
                    react_1.default.createElement(DayPickerCustomInput_1.DayPickerCustomInput, { date: props.date, onDateChange: props.onDateChange, todayButton: "Heute", editable: true, minDate: props.minDate, maxDate: props.maxDate, dayPickerVisible: dayPickerVisible, onDayPickerVisibleChange: setDayPickerVisible }),
                    react_1.default.createElement(Button_1.default, { className: "DayPickerCustomInput-Button", variant: "outline-secondary", onClick: () => setDayPickerVisible(true) },
                        react_1.default.createElement(IconCalendar_1.IconCalendar, null)),
                    react_1.default.createElement(Button_1.default, { variant: "outline-secondary", onClick: () => handlePrevNext(1), disabled: toDate >= props.maxDate },
                        react_1.default.createElement(IconChevronRight_1.IconChevronRight, null))),
                react_1.default.createElement("h3", { className: "from-to-dates mb-1 mx-4" },
                    react_1.default.createElement("span", { className: "text-nowrap" },
                        dateUtils.WEEKDAYS_SHORT[fromDate.getDay()],
                        ",",
                        " ",
                        dateUtils.formatDate(fromDate)),
                    props.view !== "day" && (react_1.default.createElement("span", { className: "text-nowrap" },
                        " ",
                        "\u2013 ",
                        dateUtils.WEEKDAYS_SHORT[toDate.getDay()],
                        ",",
                        " ",
                        dateUtils.formatDate(toDate)))),
                renderedViewArea()))));
};
exports.BookingFilters = BookingFilters;
